export default "__VITE_PUBLIC_ASSET__503b23b0__"